import { Component, Prop, Vue } from 'vue-property-decorator';
import Category from '@/category/Category';
import Marker from '@/marker/Marker';

@Component
export default class CategoriesWithMarkers extends Vue {
    @Prop({ type: Array, required: true })
    categories!: Array<Category> ;

    public get categoriesWithMarkers() {
        return this.categories
            .filter(category => this.markersByCategory(category.id).length > 0)
            .map(category => {
                return { ...category, markers: this.markersByCategory(category.id) };
            });
    }

    private markersByCategory(categoryId: string): Array<Marker> {
        const locationId = this.$route.params.location;
        return Marker.query()
            .where((marker: Marker) => {
                return marker.category_id === categoryId && marker.location_id === locationId;
            })
            .withAllRecursive()
            .get();
    }
}
